import styled, { css } from 'styled-components';

import { floorGameColor as color, floorGameDuration as duration, floorGameEasing as easing } from '@pkg/primitives';

import { tokens } from '../../tokens';
import { FloorActivityCardVariant } from '../../types';

interface StyledCardProps {
    $variant?: FloorActivityCardVariant;
    $spaceBefore?: boolean;
    $portable: boolean;
}

export const StyledCard = styled.div<StyledCardProps>`
    z-index: ${tokens.zindex.card};
    position: relative;
    display: grid;
    margin-top: var(--yat_activity-card-margin-top);
    border-radius: ${tokens.card.wrapper.radius}px;

    ${({ $portable, $spaceBefore }) =>
        !$portable &&
        css`
            --yat_activity-card-bg-color: ${color.eerie};
            --yat_activity-card-margin-top: ${$spaceBefore ? tokens.card.wrapper.spaceBefore : 0}px;
            background-color: var(--yat_activity-card-bg-color);
            box-shadow: 0 4px 32px rgba(0, 0, 0, 0.2);
            transition: background-color ${duration.normal}ms ${easing.cubic};
        `}

    ${({ $variant, $portable }) => {
        if ($variant === FloorActivityCardVariant.Light && !$portable) {
            return css`
                --yat_activity-card-bg-color: rgba(255, 255, 255, 0.1);
            `;
        }
    }};
`;
